package br.com.texeratx.boardgametimeapp.domain.usecases.login

import br.com.texeratx.boardgametimeapp.data.repository.LoginRepository

class ResetPasswordUseCase(
    private val repository: LoginRepository
) {
    suspend operator fun invoke(email: String, code: String, newPassword: String): Result<String> {
        return try {
            val response = repository.resetPassword(email, code, newPassword)
            Result.success(response.message)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
